<template>
  <div class="row d-flex justify-content-center">
    <div class="col-10 mt-2">
      <el-card shadow="always" class="p-0" style="border-radius: 10px;" :body-style="{ padding: '0px' }">
        <div class="row bg-navy py-2 px-3 mb-5">
          <div class="col-12 text-center">
            <h3 class="mb-0 text-white text-uppercase">Additional Documents</h3>
          </div>
        </div>
        <div class="mx-5">
          <div class="row">
            <div class="col-6">
              <h3 class="text-navy mb-3">License Check</h3>
              <p>As part of our anti-money laundering policy (AML) we are requires to verify your identity. To do this we
                require certain documentation.</p>
              <div class="row">
                <div class="col-4">
                  <div class="bg-navy py-4 rounded-lg">
                    <div class="row">
                      <div class="col-7 text-right">
                        <i class="fa fa-user text-grey-celeste" style="font-size: 120px;"></i>
                      </div>
                      <div class="col-4">
                        <i class="fa fa-address-card text-grey-celeste"
                          style="font-size: 60px;transform: scale(-1, 1)"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-8">
                  <div class="bg-lightgrey p-4 mx-5">
                    <h3 class="text-navy mb-3">Contact One License Check</h3>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="text-uppercase">
                        Front
                        <el-button class="action-btn text-uppercase rounded ml-1" size="small" plain type="primary"
                          style="width: 70px;">
                          Upload
                        </el-button>
                      </div>
                      <div class="text-uppercase">
                        Back
                        <el-button class="action-btn text-uppercase rounded ml-1" size="small" plain type="primary"
                          style="width: 70px;">
                          Upload
                        </el-button>
                      </div>
                    </div>
                  </div>
                  <div class="bg-lightgrey p-4 mx-5 mt-3">
                    <h3 class="text-navy mb-3">Contact Two License Check</h3>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="text-uppercase">
                        Front
                        <el-button class="action-btn text-uppercase rounded ml-1" size="small" plain type="primary"
                          style="width: 70px;">
                          Upload
                        </el-button>
                      </div>
                      <div class="text-uppercase">
                        Back
                        <el-button class="action-btn text-uppercase rounded ml-1" size="small" plain type="primary"
                          style="width: 70px;">
                          Upload
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <h3 class="text-navy mb-3">Partnership Agreement</h3>
              <p>Please upload a copy of the partnership agreement for _____ or a letter verifying the partnership from
                responsible accountant</p>
              <div class="bg-lightgrey p-4 mt-3 w-50">
                <h3 class="text-navy mb-3">Partnership agreement or Verification letter</h3>

                <el-button class="action-btn text-uppercase rounded ml-1" size="small" plain type="primary"
                  style="width: 70px;">
                  Upload
                </el-button>
              </div>
            </div>
          </div>
          <div class="row my-4">
            <div class="col-12 text-right">
              <el-button class="action-btn text-uppercase" type="primary" @click="$emit('save-data')">
                Proceed
              </el-button>
              <el-button class="action-btn  text-uppercase btn-green" type="primary" @click="$emit('save-data')">
                Save progress
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>

export default {
  props: {
  },
  mounted() {

  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>